import { applyMiddleware, combineReducers, createStore } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";
import { getFirebase } from "react-redux-firebase";
import reducers from "./reducers";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";

// redux-first-history

// middleware
const enhancers = composeWithDevTools(applyMiddleware(thunk.withExtraArgument(getFirebase)));

// redux-persist
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["alternateArt", "clipboard", "settings"],
};
const rootReducer = combineReducers({
  ...reducers,
});
const persistedReducer = persistReducer(persistConfig, rootReducer);

export default function configureStore(preloadedState) {
  const store = createStore(persistedReducer, preloadedState, enhancers);
  const persistor = persistStore(store);
  return { persistor, store };
}
